import {FC, useState} from 'react'
import {TimeSlot} from "../../types";
import {getCalendar} from "../../wordpress/operations/get-calendar";
import {bookingCalendar} from "../../constants/global";
import {checkSpotsAvailability, postReservation} from "../../wordpress/operations/post-reservation";
import Submission from "../Submission";
import content from "../main/Content";

interface Props {
    slots:TimeSlot[],
    booking:Booking,
    setBooking:Function,
    content:Content
}

const TimeSelect: FC<Props> = ({slots, booking, setBooking, content}) => {

    const [selectedId, setSelectedId] = useState<string>(null);
    if(booking.booking_flow === 'default') {
        return;
    }

    const handleClick = (slot:any) => {
        booking.date = slot.date
        switch (booking.booking_flow) {
            case 'window':
                booking.window.date = slot.date
                setSelectedId(slot.id)
                booking.window.spot_id = slot.id
                booking.hjulskifte.date = null
                booking.hjulskifte.spot_id = null
                break;
            default:
                booking.hjulskifte.date = slot.date
                setSelectedId(slot.id)
                booking.hjulskifte.spot_id = slot.id
                break;
        }

        booking.submission.name = 'Vänta på plats'
        booking.submission.time = slot.time
        booking.submission.slug = booking.submission.slug ? booking.submission.slug : 'vanta-pa-plats'
        booking.submission.type = ['time']
        setBooking({
            ...booking,
        })
        // Send reservation
        postReservation(booking).then((val) => {
            if(val.booked === true) {
                booking.date = null
                booking.window.date = booking.hjulskifte.date = null
                booking.window.spot_id = booking.hjulskifte.spot_id = null
                booking.submission.name = ''
                booking.submission.time = null
                booking.submission.slug = ''
                booking.submission.type = []
                booking.modal = 6;
                setBooking({
                    ...booking,
                })
                slot.booked = true
            }
        })
    }

    if(!slots.length)
       return

    if(!booking.date)
        return

    if(slots[0].time === 'all day' || slots[0].time === 'all day plain')
        return <></>

    return (
        <div className="time-select">
            <ul>
                {slots.map((slot:TimeSlot, i:number) => (
                    <li className={!slot.booked ? slot.id === selectedId ? 'selected' : '' : 'booked'} key={slot.id} onClick={() => handleClick(slot)}>{slot.time}</li>
                ))}
            </ul>
            <Submission booking={booking} setBooking={setBooking} content={content}/>
        </div>
    )
};

export default TimeSelect
